import { createFileRoute, redirect } from "@tanstack/react-router";

// Den engelska strukturen är /en/*. Den här URL:en var en exakt dubblett med
// samma H1 som /en/film-production-sweden och låg dessutom i sitemapen, vilket
// gav två konkurrerande engelska sidor för samma sökintention.
// Nu permanent omdirigering — inget innehåll, ingen sitemap-post, ingen hreflang.
export const Route = createFileRoute("/english/film-production-sweden")({
  beforeLoad: () => {
    throw redirect({ to: "/en/film-production-sweden", replace: true, statusCode: 301 });
  },
});
